import React from 'react'
import './BigPig.css'

export default function BigPig() {
  return (
    <div className="BigPigDiv">Big Pig!</div>
  )
}
